<template>
  <section class="section --anchors">
    <section class="section__content">
      <h1 class="title --main" v-reveal>{{ content.title }}</h1>
      <p class="description" v-reveal="{ delay: 200 }">{{ content.description }}</p>
    </section>
    <div class="anchor-card__section" v-reveal="{ delay: 250 }">
      <div class="anchor-card__container" ref="slider">
        <ul class="anchor-card__group" ref="anchors">
          <AnchorCard :content="anchor" v-for="anchor in content.anchors" :key="anchor.key" />
        </ul>
      </div>
      <RoundTextButton
        :is-max="currentStepIsMax"
        @click="updateCurrentStep"
        class="--anchors"
        v-reveal="{ delay: 300 }"
      />
    </div>
  </section>
</template>

<script>
import { AnchorCard } from '@/components/cards'
import { RoundTextButton } from '@/components/small'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'AnchorsTimelineHeader',
  mixins: [DefaultSectionProps],
  components: { AnchorCard, RoundTextButton },
  data() {
    return {
      currentStep: 0,
    }
  },
  computed: {
    currentStepIsMax() {
      return window.innerWidth > 1400
        ? this.currentStep >= this.content.anchors.length - 3
        : this.currentStep >= this.content.anchors.length - 2
    },
  },
  methods: {
    updateCurrentStep() {
      if (!this.currentStepIsMax) this.currentStep++
      else this.currentStep = 0
    },
  },
  watch: {
    currentStep() {
      if (this.$refs.slider)
        this.$refs.slider.scrollTo({
          left: this.$refs.anchors.firstElementChild.offsetWidth * this.currentStep,
          behavior: 'smooth',
        })
    },
  },
}
</script>
